import { styled, Text } from '@/theme/index';

export const ValidationErrorMessage = styled(Text)(({ theme }) => ({
  color: theme.palette.error.main,
  textAlign: 'center',
  height: theme.spacing(2.5), // reserves space for the validation message to present layout shifts
}));
